import React from "react";
import { observer } from "mobx-react-lite";
import { Button } from "@blueprintjs/core";

const AVAILABLE_SIZES = [
  { width: 1290, height: 2796 },
  { width: 2064, height: 2752 }
];

export const ResizePanel = observer(({ store }) => {
const handleSizeChange = (width, height) => {
    store.activePage.setSize({ width, height });
  };

  return (
    <div>
      {AVAILABLE_SIZES.map(({ width, height }, i) => (
        <Button
          key={i}
          style={{ width: "100%", marginBottom: "20px" }}
          onClick={() => {
handleSizeChange(width, height);
          }}
        >
          {width}x{height}
        </Button>
      ))}
    </div>
  );
});

